export const LOCAL_CATEGORY_ARTWORK_BASE_URL = '/images/planning/categories';

export const PLANNING_CATEGORY_ARTWORK_S3_BASE_URL =
  'https://cityscope-images.s3.eu-north-1.amazonaws.com/planning/categories';

const normalizeBaseUrl = (value: string) => value.trim().replace(/\/+$/, '');

export const PLANNING_CATEGORY_ARTWORK_BASE_URL = normalizeBaseUrl(
  process.env.NEXT_PUBLIC_PLANNING_CATEGORY_ARTWORK_BASE_URL ||
    PLANNING_CATEGORY_ARTWORK_S3_BASE_URL
);

export const getPlanningCategoryArtworkUrl = (fileName: string) =>
  `${PLANNING_CATEGORY_ARTWORK_BASE_URL}/${fileName.replace(/^\/+/, '')}`;

export const PLANNING_CATEGORY_ARTWORK = {
  new_build_major: getPlanningCategoryArtworkUrl('new_build_major_v2.webp'),
  change_of_use_conversions: getPlanningCategoryArtworkUrl('change_of_use_conversions.webp'),
  short_term_lets: getPlanningCategoryArtworkUrl('short_term_lets.webp'),
  extensions_enlargements: getPlanningCategoryArtworkUrl('extensions_enlargements.webp'),
  demolition: getPlanningCategoryArtworkUrl('demolition.webp'),
  outbuildings_ancillary: getPlanningCategoryArtworkUrl('outbuildings_ancillary.webp'),
  windows_doors_glazing: getPlanningCategoryArtworkUrl('windows_doors_glazing.webp'),
  roof_works_dormers: getPlanningCategoryArtworkUrl('roof_works_dormers.webp'),
  mechanical_services: getPlanningCategoryArtworkUrl('mechanical_services.webp'),
  renewables_energy: getPlanningCategoryArtworkUrl('renewables_energy.webp'),
  landscaping_boundaries: getPlanningCategoryArtworkUrl('landscaping_boundaries.webp'),
  parking_access: getPlanningCategoryArtworkUrl('parking_access.webp'),
  external_lighting: getPlanningCategoryArtworkUrl('external_lighting.webp'),
  trees_ecology: getPlanningCategoryArtworkUrl('trees_ecology.webp'),
  legal_admin: getPlanningCategoryArtworkUrl('legal_admin.webp'),
  interiors_accessibility: getPlanningCategoryArtworkUrl('interiors_accessibility.webp'),
  shopfront_signage: getPlanningCategoryArtworkUrl('shopfront_signage.webp'),
  public_realm_community: getPlanningCategoryArtworkUrl('public_realm_community.webp'),
  telecommunications: getPlanningCategoryArtworkUrl('telecommunications.webp'),
} as const;
